import { FC, useState } from 'react';
import Button from '../Button';
import styled from 'styled-components';
import { COLORS } from '@/app/constants';
import { InfoCircle3 } from '../../iconComponents';
import { sendMetrik } from '@/app/utils/sendMetrik';

interface Props {
  onClick: (() => void) | undefined;
}

const HelpChooseChildPsy2: FC<Props> = ({ onClick }) => {

  const [isTipVisible, setIsTipVisible] = useState<boolean>(false);

  const handleInside = () => {
    setIsTipVisible(true);
  };

  const handleOutside = () => {
    setIsTipVisible(false);
  };

  return (

    <Container>
      <Title>
        Помочь с подбором специалиста?
      </Title>
      <Description>
        Наша служба заботы здесь, чтобы помочь вам!
      </Description>
      <ButtonHelp styleType='primary' onClick={() => {
        sendMetrik('reachGoal', 'child_select_specialist');
        onClick && onClick();
      }}>
        Подобрать специалиста
        <InfoWrapper onMouseEnter={handleInside} onMouseLeave={handleOutside}>
          <InfoCircle3/>
        </InfoWrapper>
        {isTipVisible &&
          <Message>
            Оставьте свои данные, и наша команда заботы свяжется с вами в ближайшее время. Наши рабочие часы с 9:00 до 21:00 GMT+3 (Москва).
          </Message>
        }
        {isTipVisible && <img src="/assets/images/filters/tip.png" alt=""/>}
      </ButtonHelp>
    </Container>

  );

};

export default HelpChooseChildPsy2;

const Container = styled.div`
  padding: 20px;
  border-radius: 24px;
  box-shadow: 0px 8px 32px #F4F5F6;
`;

const Title = styled.div`
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
  color: #212731;
`;

const Description = styled.div`
margin-bottom: 24px;
  font-size: 12px;
  line-height: 1.4;
  color: #212731;
`;

const ButtonHelp = styled(Button)`
  font-size: 13px;
  padding: 8px 40px;

  img {
    position: absolute;
    top: -5px;
    right: 12px;
    z-index: 11;
  }
`;

const Message = styled.div`
  position: absolute;
  width: 262px;
  bottom: 33px;
  left: 140px;
  padding: 6px 8px;
  border-radius: 8px;

  background-color: white;
  box-shadow: 0px 10px 30px rgba(31, 34, 61, 0.1);

  font-size: 13px;
  line-height: 1.2;
  color: ${COLORS.grayscale600};
  z-index: 10;
`;

const InfoWrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 18px;

  path {
    fill: white;
  }
`;


